import React from "react";

const Footer = () => (
    <div className="footer">
        Powered by Realtime Development &reg;<br />ติดต่อ : support@realtime.co.th
    </div>
);

export default Footer;